module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-button"
  }, [_c('div', {
    staticClass: "general-progress"
  }, [_c('button', {
    staticClass: "button open",
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    class: ("progress-bar " + _vm.generalStatus),
    style: (("width: " + (_vm.progress || 0) + "%;"))
  }), _vm._v(" "), _c('p', {
    staticClass: "open__text"
  }, [_vm._t("default"), _vm._v("\n          " + _vm._s((_vm.buttonText + " (" + _vm.uploadsCount + ") ")) + "\n          "), (_vm.isOpen) ? _c('i', {
    staticClass: "fa fa-caret-up open__icon ml-20",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down open__icon ml-20",
    attrs: {
      "aria-hidden": "true"
    }
  })], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7becb363","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/uploadManager/UploadManagerButton.vue
// module id = 954
// module chunks = 0